import { gql } from '@apollo/client'

import { TradeFragment } from './trade.fragment'
import { CompanyFragment } from './company.fragment'

export const SequenceTaskTemplateFragment = gql`
  fragment SequenceTaskTemplateFragment on SequenceTaskTemplate {
    id
    name
    description
    startRow
    startDay
    duration
    workforce
    trade {
      ...TradeFragment
    }
    company {
      ...CompanyFragment
    }
  }
  ${TradeFragment}
  ${CompanyFragment}
`

export const SequenceTemplateFragment = gql`
  fragment SequenceTemplateFragment on SequenceTemplate {
    id
    createdDate
    updatedDate
    deletedDate
    name
    description
    index
    tasks {
      ...SequenceTaskTemplateFragment
    }
  }
  ${SequenceTaskTemplateFragment}
`
